import React from 'react';
import cookie from 'react-cookies';
import SideBarLink from './SideBarLink';
import MultiLevelLink from './MultiLevelLink';
import { createRedirectUrl } from '../apiUtils';

const SidebarTopNav = ({ projectId, version, pageId, toggleSidebar, tutorialActions }) => {
  let token = cookie.load('token');
  if (!token) {
    token = '';
  }
  let domainName = window.location.hostname;
  let redirectUrl = createRedirectUrl();
  const developerApiDomain = domainName.split('.')[0];
  const topNavLinks = () => {
    if (pageId) {
      return (
        <>
          <SideBarLink
            title="Components"
            onClick={(e) => toggleSidebar(e, 'BLOCKS')}
            icon="webconnect-plus-square"
          />
          <SideBarLink
            title="Pages"
            onClick={(e) => toggleSidebar(e, 'PAGES')}
            icon="webconnect-file-alt"
          />
          <SideBarLink
            title="Collections"
            onClick={(e) => toggleSidebar(e, 'COLLECTIONS')}
            icon="webconnect-database"
          />
          <SideBarLink
            title="Snippets"
            onClick={(e) => toggleSidebar(e, 'TEMPLATES')}
            icon="webconnect-bars"
          />
          <SideBarLink
            title="Events"
            onClick={(e) => toggleSidebar(e, 'EVENTS')}
            icon="webconnect-diagram-3-fill"
          />
          <li className="gjs-tablinks position-relative" title="Plugins">
            <a
              href={`${redirectUrl}plugin/${version}/v/${projectId}?token=${token}`}
              className="icon-link stretched-link"
            >
              <i className="wb webconnect-tools"></i>
            </a>
          </li>
          <li className="gjs-tablinks position-relative" title="External APIs">
            <a
              href={`${redirectUrl}externalapi/${version}/v/${projectId}?token=${token}`}
              className="icon-link stretched-link"
            >
              <i className="wb webconnect-rocket"></i>
            </a>
          </li>
          <SideBarLink
            title="Assets"
            onClick={(e) => toggleSidebar(e, 'ASSETS')}
            icon="webconnect-image_solid"
          />
        </>
      );
    }
  };

  const bottomNavLinks = () => {
    return (
      <ul className="align-bottom" id="sidebar-submenu">
        <MultiLevelLink icon="webconnect-file-ppt-fill" title="Project">
          <ul>
            <SideBarLink
              href={`${process.env.REACT_APP_ORGANIZATION}dashboard`}
              title="Project Dashboard"
              target="_blank"
              icon="webconnect-grid-fill"
              text="Dashboard"
            />
            <SideBarLink
              href={`${process.env.REACT_APP_ORGANIZATION}${projectId}/project-detail`}
              title="Project Settings"
              target={'_blank'}
              icon="webconnect-gear"
              text="Settings"
            />
          </ul>
        </MultiLevelLink>
        <MultiLevelLink icon="webconnect-cogs" title="Settings">
          <ul>
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/appConstant?token=${token}`}
              title="App Setting"
              icon="webconnect-home"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/custom-css?token=${token}`}
              title="Custom CSS"
              icon="webconnect-paint-brush"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/custom-js?token=${token}`}
              title="Custom JavaScript"
              icon="webconnect-puzzle"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/custom-theme?token=${token}`}
              title="Custom HTML Theme"
              icon="webconnect-file-zip"
            />
            <SideBarLink
              href={`${redirectUrl}custom-component/${version}/v/${projectId}/customComponent?token=${token}`}
              title="Custom Component"
              icon="webconnect-easel"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/pwa-config?token=${token}`}
              title="PWA Configuration"
              icon="webconnect-phone"
            />
            {/* Todo: this route is not exist (/setting/dbExport) */}
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/dbExport?token=${token}`}
              title="Database Dump Export"
              icon="webconnect-database"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/devKey?token=${token}`}
              title="Developer API"
              icon="webconnect-key"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/encryption-section?token=${token}`}
              title="Data Encryption"
              icon="webconnect-shield-lock"
            />
            <SideBarLink
              href={`${redirectUrl}template/${version}/v/${projectId}/?token=${token}`}
              title="Templates"
              icon="webconnect-file-alt"
            />
            <SideBarLink
              href={`${redirectUrl}data-connector/${version}/v/${projectId}?token=${token}`}
              title="Data Source"
              icon="webconnect-hdd-stack-fill"
            />
            <SideBarLink
              href={`${redirectUrl}externalapi/${version}/v/${projectId}?token=${token}`}
              title="External APIs"
              icon="webconnect-rocket"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/localization-section?token=${token}`}
              title="Localization"
              icon="wb webconnect-edit"
            />
            <SideBarLink
              href={`${redirectUrl}webhook/${version}/v/${projectId}?token=${token}`}
              title="Webhooks"
              icon="webconnect-plug-fill"
              text="Webhooks"
            />
            <SideBarLink
              href={`${redirectUrl}logger/${version}/v/${projectId}?token=${token}`}
              title="System Logs"
              icon="webconnect-file-text"
              text="System Logs"
            />
            <SideBarLink
              href={`${redirectUrl}app-setting/${version}/v/${projectId}/setting/version?token=${token}`}
              title="Project Version"
              icon="webconnect-patch-plus"
            />
            <SideBarLink
              href={`${redirectUrl}schedule/${version}/v/${projectId}?token=${token}`}
              title="Background Task"
              icon="webconnect-alarm"
              text="Background Task"
            />
            <SideBarLink
              href={`${redirectUrl}permission/${version}/v/${projectId}?token=${token}`}
              title="Delete Permissions"
              icon="webconnect-vector-pen"
              text="Delete Permissions"
            />
            <SideBarLink
              href={`${redirectUrl}deployment-setting/${version}/v/${projectId}/code-export?token=${token}`}
              title="Code Export"
              icon="webconnect-cloud-download"
              text="Code Export"
            />
          </ul>
        </MultiLevelLink>
        <SideBarLink
          href={`${redirectUrl}webhook/${version}/v/${projectId}?token=${token}`}
          onClick={tutorialActions.toggleTutorialModal}
          icon="webconnect-youtube"
          title="Tutorials"
        />
        <MultiLevelLink icon="webconnect-info-circle" title="Help/Tutorials">
          <ul>
            <SideBarLink
              href="https://academy.drapcode.com/"
              title="Product Manual"
              icon="webconnect-file-alt"
              target="_blank"
            />
            <SideBarLink
              href={`https://${developerApiDomain}.api.drapcode.io/api/v1/docs`}
              title="Developer APIs"
              icon="webconnect-rocket"
              target="_blank"
            />
            <SideBarLink
              href="https://drapcode.com/contact-us"
              title="Need Help?"
              icon="webconnect-envelope"
              target="_blank"
            />
            <SideBarLink
              href="https://join.slack.com/t/drapcode/shared_invite/zt-xvo04sdw-Whf_4z3KsWTu1wd8R_6rYQ"
              title="Slack Community"
              icon="webconnect-slack"
              target="_blank"
            />
            <SideBarLink
              href="https://discord.com/channels/844860999542898708/844861000510734358"
              title="Discord Community"
              icon="webconnect-discord"
              target="_blank"
            />
            <SideBarLink
              href="https://community.drapcode.com/"
              title="Community"
              icon="webconnect-address-card"
              target="_blank"
            />
            <SideBarLink
              href="https://www.youtube.com/channel/UCGQQj8iNARSHscemk9FY5uw"
              title="Tutorials"
              icon="webconnect-youtube"
              target="_blank"
            />
            <SideBarLink
              href="https://typeform229411.typeform.com/to/ZnBQ7y6u"
              title="Feature Request?"
              icon="webconnect-edit-solid"
              target="_blank"
            />
          </ul>
        </MultiLevelLink>
      </ul>
    );
  };

  return (
    <ul>
      {topNavLinks()}
      {bottomNavLinks()}
    </ul>
  );
};

export default SidebarTopNav;
